import '../../resources/css/list.css';

export default function List({ title, items }) {

    const renderedItems = (items || []).map((item, index) => {
        return <li key={ index}>
            <i className="fa fa-check-square"></i>
            {item}</li>
    });

    return (
        <div className="list">
            <p className="bold title-h5 color-purple">{title}</p>
            <div>
                {renderedItems && <ul className="list-items">{renderedItems}</ul>}
            </div>
        </div>
    );
}